import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MaterialTable from "material-table";
import { forwardRef } from 'react';
import classNames from 'classnames';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';

import { api_host, api_auth } from '../../../../common/globals/constants';

import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField/index';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import Grid from '@material-ui/core/Grid';

import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment'
import 'moment/locale/es'  
import { Button, Divider } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// Component styles
import styles from './styles';
import md5 from 'md5';
moment.locale('es')

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
const sendValues = (value, nombre, email, telefono, cargo, perfil, zona, pass, clienteusuario, subCLient, admin, user) => {
    let token = sessionStorage.getItem('key')
    let client_id = sessionStorage.getItem('client_id')
    let method = 'POST'
    if (value == 2){
        method = 'PATCH'
    }
    if (value == 3){
        method = 'DELETE'
    }
    return new Promise(resolve => {
        setTimeout(() => {
            if (value == 1) {
                fetch(api_host+`/reporte/general/perfil/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, email: email, telefono: telefono, cargo: cargo, 
                                            reporte_perfil_id: perfil, zona_horaria_id: zona, clave: pass, cliente_id: client_id, 
                                            cliente_subcliente: subCLient, admin: admin, userlog: user}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            } else if(value == 2){
                fetch(api_host+`/reporte/general/perfil/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, email: email, telefono: telefono, cargo: cargo, 
                                            reporte_perfil_id: perfil, zona_horaria_id: zona, clave: pass, cliente_id: client_id, 
                                            user: clienteusuario, cliente_subcliente: subCLient, admin: admin, userlog: user}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            } else if(value == 3){
                fetch(api_host+`/reporte/general/perfil/?token=${token}`, {
                    method: method, // or 'PUT'
                    body: JSON.stringify({token: token, nombre: nombre, email: email, telefono: telefono, cargo: cargo, 
                                            reporte_perfil_id: perfil, zona_horaria_id: zona, clave: pass, cliente_id: client_id, 
                                            user: clienteusuario, admin: subCLient, userlog: admin}), // data can be `string` or {object}!
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(res => res.json())
                    .catch(error => console.error('Error:', error))
                    .then(response => {
                        if (response.status == 3) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                    );
            }
        }, 100);
    });
};

class UserList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            //statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            rows: null,
            noMonCum: null,
            downCum: null,
            //date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            addEl: null,
            editEl: null,
            deleteEl: null,
            values: {
                email: '',
                name: '',
                phone: '',
                cargo: '',
                emailEdit: '',
                nameEdit: '',
                phoneEdit: '',
                cargoEdit: '',    
            },
            isChanged: false,
            open: false,
            isValid: false,
            validEmail: false,
            validName: false,
            value: 0,
            valueCreate: 0,
            timezone: {},
            //isRefresh: this.props.params.isRefresh,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        let token = sessionStorage.getItem('key')
        Promise.all([
            fetch(api_host+`/reporte/general/usuarios/?token=${token}&start=${new Date().getTime()}`),
            fetch(api_host+`/reporte/general/reporte_perfil_y_zona_horaria/?token=${token}&start=${new Date().getTime()}`),
            fetch(api_host+`/reporte/general/cliente_subcliente/?token=${token}&start=${new Date().getTime()}`)
        ])
            .then(([res1, res2, res3]) => {
                return Promise.all([res1.json(), res2.json(), res3.json()])
            })
            .then(([res1, res2, res3]) => {
                // Se define el state de acuerdo a la petición y respuesta de la promesa 
                if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
                    localStorage.setItem('isAuthenticated', false);
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(res1, res2, res3)
                    } catch (error) {
                    this.setState({
                        dataError: true,
                        data: null,
                        isLoading: false
                    });
                }
            }
        });
    }

    // Helper para procesar la data de la petición a la API

    processData = (data, dataTimeProfile, dataSubClient) => {
            let user = sessionStorage.getItem('user')
            let userList = data[0]
            let arrayRows = []
            Object.keys(userList).map((key0)=> {
                let rows = {}
                rows['clienteUsuarioId'] = userList[key0].cliente_usuario_id
                rows['nombre'] = userList[key0].nombre  
                rows['cargo'] = userList[key0].cargo  
                rows['telefono'] = userList[key0].telefono  
                rows['email'] = userList[key0].email
                rows['editar'] = true 
                rows['perfilId'] = userList[key0].reporte_perfil.reporte_perfil_id
                rows['nombrePerfil'] = userList[key0].reporte_perfil.nombre
                rows['zonaHorariaId'] = userList[key0].zona_horaria_id
                rows['subCliente'] = userList[key0].cliente_subcliente
                if (userList[key0].cliente_usuario_id != user){
                    if (userList[key0].reporte_perfil.reporte_perfil_id != 4 
                        && userList[key0].reporte_perfil.reporte_perfil_id != 6 
                        && userList[key0].reporte_perfil.reporte_perfil_id != undefined) {
                        rows['eliminar'] = false
                    } else {
                        rows['eliminar'] = true
                    }
                } else {
                    rows['eliminar'] = true
                }
                arrayRows.push(rows)
            })
            this.setState({
                timezone: dataTimeProfile['zona_horaria'],
                profile: dataTimeProfile['reporte_perfil'],
                subclient: dataSubClient,
                rows : arrayRows,
                isLoading: false,
                dataError: false,
            }); 
       
    }
    handleShowAdd = event => {
        this.setState({
            addEl: event.currentTarget,
            values:{
                subclientCreate: [-1],
                subclientEdit: [-1],
                timezoneId: "129",
                profileId: "12"
            },
            isChanged: false,
        });
    };

    handleCloseAdd = () => {
        this.setState({
            addEl: null,
            validEmail: false,
            validName: false,
            values:{
                subclientCreate: [-1],
                subclientEdit: [-1],
            },
            isChanged: false,
        });
    };

    handleShowEdit = (event, value) => {
        this.setState({
            editEl: event.currentTarget,
            values:{
                subclientCreate: [-1],
                emailEdit: value.email,
                nameEdit: value.nombre,
                cargoEdit: value.cargo,
                phoneEdit: value.telefono,
                clientUserEdit: value.clienteUsuarioId,
                timezoneIdEdit: value.zonaHorariaId,
                profileIdEdit: value.perfilId,
                subclientEdit: value.subCliente
            },
            isChanged: false,
        });
    };

    handleCloseEdit = () => {
        this.setState({
            editEl: null,
            validEmail: false,
            validName: false,
            values:{
                subclientCreate: [-1],
                subclientEdit: [-1],
            },
            isChanged: false,
        });
    };

    handleShowDelete = (event, value) => {
        this.setState({
            deleteEl: event.currentTarget,
            values:{
                subclientCreate: [-1],
                subclientEdit: [-1],
                name: value.nombre,
                userId: value.clienteUsuarioId
            },
            isChanged: false,
        });
    };
    handleCloseDelete = () => {
        this.setState({
            deleteEl: null,
            values:{
                subclientCreate: [-1],
                subclientEdit: [-1],
            },
            isChanged: false,
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;     
        newState['isChanged'] = true;
        this.setState(newState);
    };

    handleDeleted = async(value) => {
        const {addEl, editEl, values, isChanged} = this.state;
        let admin_id = sessionStorage.getItem('admin_id')
        let user = sessionStorage.getItem('user')
        var value = 3
        var nombre = ""
        var email = ""
        var telefono = ""
        var cargo = ""
        var perfil = 0
        var zona = 0
        var pass = ""
        var passConfirm = ""
        var clienteusuario = values.userId
        try {
            this.setState({ isLoading: true });
            var ok = await sendValues(value, nombre, email, telefono, cargo, perfil, zona, pass, clienteusuario, admin_id, user);
            if (ok){
                this.setState({
                    isLoading: true,
                    isValid: true,                   
                    open: true,
                    deleteEl: null

                });
                this.getDataFromAPI();
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,                   
                    open: true
                });
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleSaved = async (value) => {
        const {addEl, editEl, values, isChanged} = this.state;
        let admin_id = sessionStorage.getItem('admin_id')
        let user = sessionStorage.getItem('user')
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        var value = 0
        var nombre = ""
        var email = ""
        var telefono = ""
        var cargo = ""
        var perfil = 0
        var zona = 0
        var pass = ""
        var passConfirm = ""
        var clienteusuario = ""
        var subClient = []
        if (showAddEl){
            value = 1
            nombre = values.name
            email = values.email
            telefono = values.phone
            cargo = values.cargo
            perfil = parseInt(values.profileId)
            zona = parseInt(values.timezoneId)
            pass = values.newPass
            passConfirm = values.confirmPass
            subClient = values.subclientCreate
        } else if (showEditEl){
            value = 2
            nombre = values.nameEdit
            email = values.emailEdit
            telefono = values.phoneEdit
            cargo = values.cargoEdit
            perfil = parseInt(values.profileIdEdit)
            zona = parseInt(values.timezoneIdEdit)
            pass = values.newPassEdit
            passConfirm = values.confirmPassEdit
            clienteusuario = values.clientUserEdit
            subClient = values.subclientEdit
        } 
        var isValid = false
        if (value == 1){
            if (isChanged){
                if (pass != undefined && pass != "" && pass == passConfirm){
                    isValid = true
                } else {
                    isValid = false
                }
            } else{
                isValid = false
            }
        } else if (value == 2) {
            if (isChanged){
                if (pass){
                    if (pass == passConfirm){
                        isValid = true
                        pass = md5(values.newPassEdit)
                    } else {
                        isValid = false
                    }
                } else {
                    isValid = true
                }
            } else {
                isValid = false
            }
        }
        if(isValid){
            try {
                this.setState({ isLoading: true });
                var ok = await sendValues(value, nombre, email, telefono, cargo, perfil, zona, pass, clienteusuario, subClient, admin_id, user);
                if (ok){
                    this.setState({
                        isLoading: true,
                        isValid: true,                   
                        open: true,
                        editEl: null,
                        addEl: null,
                        validEmail: false,
                        validName: false,
                    });
                    this.getDataFromAPI();
                } else {
                    this.setState({
                        isLoading: false,
                        isValid: false,                   
                        open: true,
                    });
                }
            } catch (error) {
                this.setState({
                    isLoading: false,
                    //serviceError: error,
                    isValid: false,
                    open: true
                });
            }
        } else {
            this.setState({
                isLoading: false,
                //serviceError: error,
                isValid: false,
                open: true
            });
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })
    };
    
    validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;      
        if (re.test(email)) {
            this.setState({
                validEmail: false,
            });
        } else {
            this.setState({
                validEmail: true,
            });
        }
    }
    validateName = (name) => {
        if (!name) {
            this.setState({
                validName: true,
            });
        } else {
            this.setState({
                validName: false,
            });
        }
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };
    handleCreateChange = (event, newValue) => {
        this.setState({
            valueCreate: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };

    handleToggleCreate = value => () => {
        const {email, name, phone, cargo, typeEdit, timezoneId, profileId, subclientCreate, newPass, confirmPass} = this.state.values
        if (subclientCreate[0] != -1) {
            const currentIndex = subclientCreate.indexOf(parseInt(value));
            const newChecked = [...subclientCreate];
            var check = false
            if(newChecked.includes(value)){
                newChecked.splice(currentIndex, 1);
            } else {
                newChecked.push(value)
            }
            this.setState({
                values:{
                    email: email,
                    name: name,
                    cargo: cargo,
                    phone: phone,
                    //typeEdit: value.tipoId,
                    timezoneId: timezoneId,
                    profileId: profileId,
                    subclientCreate: newChecked,
                    newPass: newPass,
                    confirmPass: confirmPass
                }, isChanged: true
            })
        } else{
            const newChecked = [];
            newChecked.push(value)
            this.setState({
                values:{
                    email: email,
                    name: name,
                    cargo: cargo,
                    phone: phone,
                    //typeEdit: value.tipoId,
                    timezoneId: timezoneId,
                    profileId: profileId,
                    subclientCreate: newChecked,
                    newPass: newPass,
                    confirmPass: confirmPass
                }, isChanged: true
            })
        }
    }

    handleToggle = value => () => {
        const {emailEdit, nameEdit, phoneEdit, cargoEdit, clientUserEdit, timezoneIdEdit, profileIdEdit, subclientEdit, confirmPassEdit, newPassEdit} = this.state.values
        const currentIndex = subclientEdit.indexOf(parseInt(value));
        const newChecked = [...subclientEdit];
        var check = false
        if(newChecked.includes(value)){
            newChecked.splice(currentIndex, 1);
        } else {
            newChecked.push(value)
        }
        this.setState({
            values:{
                emailEdit: emailEdit,
                nameEdit: nameEdit,
                cargoEdit: cargoEdit,
                phoneEdit: phoneEdit,
                clientUserEdit: clientUserEdit,
                timezoneIdEdit: timezoneIdEdit,
                profileIdEdit: profileIdEdit,
                subclientEdit: newChecked,
                newPassEdit: newPassEdit,
                confirmPassEdit: confirmPassEdit
            }, isChanged: true
        })
    }

    render() {
        const { classes, className, ...rest } = this.props;
        const { dataError, isLoading, rows, noMonCum, downCum, addEl, editEl, 
                deleteEl, open, isValid, validEmail, validName, value, timezone, profile, subclient, valueCreate} = this.state;
        const {emailEdit, nameEdit, phoneEdit, cargoEdit, typeEdit, timezoneIdEdit, profileIdEdit, newPassEdit, confirmPassEdit, subclientEdit, 
            email, name, phone, cargo, timezoneId, profileId, newPass, confirmPass, subclientCreate } = this.state.values
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };    
        const showAddEl = Boolean(addEl);   
        const showEditEl = Boolean(editEl); 
        const showDeleteEl = Boolean(deleteEl); 
        const rootClassName = classNames(classes.root, className);
  
        if (!dataError) {
            return (<FormattedChart t={this.props.t} classes={classes} rows={rows} noMonCum={noMonCum} downCum={downCum} isLoading={isLoading} style={style} styleHidden={styleHidden}
                                    handleCloseAdd={this.handleCloseAdd} handleShowAdd={this.handleShowAdd} showAddEl={showAddEl}
                                    handleFieldChange={this.handleFieldChange}
                                    handleCloseEdit={this.handleCloseEdit} handleShowEdit={this.handleShowEdit} showEditEl={showEditEl} 
                                    emailEdit={emailEdit} nameEdit={nameEdit} phoneEdit={phoneEdit} typeEdit={typeEdit}
                                    handleDeleted={this.handleDeleted} handleSaved={this.handleSaved}
                                    open={open} isValid={isValid} handleClose={this.handleClose}
                                    handleCloseDelete={this.handleCloseDelete} handleShowDelete={this.handleShowDelete} showDeleteEl={showDeleteEl}
                                    validEmail={validEmail} validateEmail={this.validateEmail} 
                                    validName={validName} validateName={this.validateName} value={value} handleChange={this.handleChange}
                                    timezone={timezone} timezoneIdEdit={timezoneIdEdit} profileIdEdit={profileIdEdit}
                                    profile={profile} subclient={subclient} subclientEdit={subclientEdit}
                                    handleToggle={this.handleToggle} cargoEdit={cargoEdit}
                                    valueCreate={valueCreate} handleCreateChange={this.handleCreateChange}
                                    handleToggleCreate={this.handleToggleCreate} subclientCreate={subclientCreate}
                                    newPass={newPass} newPassEdit={newPassEdit} confirmPass={confirmPass} confirmPassEdit={confirmPassEdit}
                                    name={name} email={email} cargo={cargo} phone={phone}
                                    timezoneId={timezoneId} profileId={profileId}/>) 
        }
        else if (dataError) {
            return (<p>{this.props.t ? this.props.t('users.table.empty') : 'No hay datos..'}</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    return (
        <div>
            { props.rows == null  ? 
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                {props.t ? props.t('text.loading') : 'Cargando información...'}
            </Grid>
                </Grid>
            :
                <div style={{ maxWidth: "100%" }}>
                    {/*<Button style={{backgroundColor: 'white'}} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> Agregar contacto </Typography>
                    </Button>*/}
                    <MaterialTable
                        
                        icons={tableIcons}
                        columns={[
                                                        { width: 100, title: props.t ? props.t('users.table.column.name') : "Nombre", field: "nombre"/*, defaultGroupOrder: 0*/,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                                                        { width: 100, title: props.t ? props.t('users.table.column.email') : "E-mail", field: "email" ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              } },
                                                        { width: 100, title: props.t ? props.t('users.table.column.profile') : "Perfil", field: "nombrePerfil"/*, type: "numeric"*/ ,headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                              },
                              render: rowData => {
                                return props.t(`user-management.role.${rowData.perfilId}.nombre`) ?? rowData['nombrePerfil']
                                },
                            },
                                                        { width: 100, title: props.t ? props.t('users.table.column.phone') : "Teléfono", field: "telefono"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                              }, hidden: true },
                                                        { width: 100, title: props.t ? props.t('users.table.column.profileId') : "PerfilId", field: "perfilId"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                              }, hidden: true },
                                                        { width: 100, title: props.t ? props.t('users.table.column.edit') : "Editar", field: "editar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                              }, hidden: true },
                                                        { width: 100, title: props.t ? props.t('users.table.column.delete') : "Eliminar", field: "eliminar"/*, type: "numeric"*/,headerStyle: {
                                backgroundColor: '#0c0033',
                                color: '#FFF'
                              }, hidden: true},
                                                            { width: 100, title: props.t ? props.t('users.table.column.clientUserId') : "clienteUsuarioId", field: "clienteUsuarioId"/*, type: "numeric"*/,headerStyle: {
                                                                    backgroundColor: '#0c0033',
                                                                    color: '#FFF'
                                                                }, hidden: true},
                                                        { width: 100, title: props.t ? props.t('users.table.column.subClient') : "subCliente", field: "subCliente"/*, type: "numeric"*/,headerStyle: {
                                                                backgroundColor: '#0c0033',
                                                                color: '#FFF'
                                                                }, hidden: true}
                        ]}
                        /*data={[
                            { monitor: "Claro (cl)", paso: "Home", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Login", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Claro (cl)", paso: "Liquidaciones", minimo: 0.320, maximo: 22.700, promedio: 2.590, uptime: 100.000, downtime: 0.000, nomon: 0.000, total: 213  },
                            { monitor: "Entel (cl)", paso: "Home", minimo: 0.280, maximo: 4.580, promedio: 2.470, uptime: 99.530, downtime: 0.470, nomon: 0.000, total: 213  }
                        ]}*/
                        data={props.rows} 
                        title=" "
                        localization={{
                            grouping: {
                                groupedBy: props.t ? props.t('users.table.groupedBy') : 'Agrupar por:',
                                placeholder: props.t ? props.t('users.table.groupPlaceholder') : 'Arrastre los encabezados aquí, para agrupar',
                            },
                            body: {
                                emptyDataSourceMessage: props.t ? props.t('users.table.empty') : 'No hay datos'
                            },
                            toolbar: {
                                searchTooltip: props.t ? props.t('users.table.search.tooltip') : 'Buscar',
                                searchPlaceholder: props.t ? props.t('users.table.search.placeholder') : 'Buscar'
                            },
                            pagination: {
                                labelRowsSelect: props.t ? props.t('users.table.pagination.rows') : 'Filas',
                                labelDisplayedRows: props.t ? props.t('users.table.pagination.displayed') : ' {from}-{to} de {count}',
                                firstTooltip: props.t ? props.t('users.table.pagination.first') : 'Pri. pág.',
                                previousTooltip: props.t ? props.t('users.table.pagination.previous') : 'Pág. previa',
                                nextTooltip: props.t ? props.t('users.table.pagination.next') : 'Sig. pág.',
                                lastTooltip: props.t ? props.t('users.table.pagination.last') : 'Últ. pág'
                            },
                            header: {
                                actions: '',
                                headerStyle: {
                                    backgroundColor: '#979797',
                                    color: '#FFF'
                                }
                            },
                        }}
                        options={{
                            grouping: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#6d6d6d',
                                color: '#FFF'
                            }
                        }}
                        actions={[
                            {
                                icon: AddCircleOutlineIcon,
                                tooltip: props.t ? props.t('users.actions.add') : 'Agregar usuario',
                                isFreeAction: true,
                                //onClick: (event) => alert("You want to add a new row")
                                onClick: props.handleShowAdd
                            },
                            {
                                icon: Edit,
                                tooltip: props.t ? props.t('users.actions.edit') : 'Editar usuario',
                                //props.handleFieldChange('name', event.target.value)
                                //onClick: (event, rowData) => alert("You saved " + rowData.nombre)
                                onClick: (event, rowData) => props.handleShowEdit(event, rowData)
                            },
                            
                            rowData => ({
                                icon: DeleteOutline,
                                tooltip: props.t ? props.t('users.actions.delete') : 'Eliminar usuario',
                                onClick: (event, rowData) => props.handleShowDelete(event, rowData),
                                //disabled: rowData.eliminar,
                                hidden: rowData.eliminar
                            })
                        ]}
                    />

                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showAddEl}
                        onClose={props.handleCloseAdd}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showAddEl}>
                            <PerfectScrollbar>                           
                                    <Portlet
                                        
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                                <PortletLabel
                                                        //subtitle="Actualizar Contraseña"
                                                        title={props.t ? props.t('users.modal.title') : 'Información del usuario'}
                                                    />
                                            <IconButton  onClick={props.handleCloseAdd}><CloseIcon/></IconButton>
                                        </PortletHeader>
                                        <AppBar position="static" style={{ backgroundColor: '#525252'}}>
                                            <Tabs value={props.valueCreate} onChange={props.handleCreateChange} aria-label="simple tabs example">
                                                <Tab label={props.t ? props.t('users.tabs.user') : 'Usuario'}  />
                                                <Tab label={props.t ? props.t('users.tabs.groups') : 'Grupos'} /*disabled={!updateDisabled}*//>
                                            </Tabs>
                                        </AppBar>
                                        <PortletContent className={props.classes.porletContent}>
                                        { props.valueCreate == 0 ? 
                                            <form className={props.classes.form}>
                                                <TextField
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validName}
                                                    helperText={props.validName ? (props.t ? props.t('users.form.helper.invalidName') : 'Por favor ingrese un nombre válido') : ' '}
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.name') : 'Nombre'}
                                                    name="name"
                                                    onChange={event =>
                                                        props.handleFieldChange('name', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.name}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateEmail(event.target.value)
                                                    }
                                                    error={props.validEmail}
                                                    helperText={props.validEmail ? (props.t ? props.t('users.form.helper.invalidEmail') : 'Por favor ingrese un email válido') : ' '}
                                                    required
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.email') : 'E-mail'}
                                                    name="email"
                                                    onChange={event =>
                                                        props.handleFieldChange('email', event.target.value)
                                                    }
                                                    type="email"
                                                    value={props.email}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.phone') : 'Teléfono'}
                                                    name="phone"
                                                    inputProps={{ pattern:'\x2b[0-9]+' }}
                                                    onChange={event =>
                                                        props.handleFieldChange('phone', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.phone}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    /*required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validCargo}
                                                    helperText={props.validCargo ? 'Por favor ingrese un cargo válido' : ' '}*/
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.position') : 'Cargo'}
                                                    name="cargo"
                                                    onChange={event =>
                                                        props.handleFieldChange('cargo', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.cargo}
                                                    variant="outlined"
                                                />
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                    {props.t ? props.t('users.form.profile') : 'Perfil'}
                                                    </InputLabel>
                                                    { props.isLoading ? <div></div> : 
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            onChange={event =>
                                                                props.handleFieldChange('profileId', event.target.value)
                                                            }
                                                            defaultValue={props.profileId}
                                                            inputProps={{
                                                                name: 'name',
                                                                id: 'uncontrolled-native',
                                                            }}
                                                        >
                                                            {Object.keys(props.profile).map((key) => {                                                        
                                                                return <option value={props.profile[key]['reporte_perfil_id']}>{
                                                                    props.t(`user-management.role.${props.profile[key]['reporte_perfil_id']}.nombre`) ?? props.profile[key]['nombre']
                                                                }</option>
                                                            })}
                                                        </NativeSelect>}
                                                </FormControl>
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                    {props.t ? props.t('users.form.timezone') : 'ZonaHoraria'}
                                                    </InputLabel>
                                                    { props.isLoading ? <div></div> : 
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            onChange={event =>
                                                                props.handleFieldChange('timezoneId', event.target.value)
                                                            }
                                                            defaultValue={props.timezoneId}
                                                            inputProps={{
                                                                name: 'name',
                                                                id: 'uncontrolled-native',
                                                            }}
                                                        >
                                                            {Object.keys(props.timezone).map((key) => {                                                        
                                                                return <option value={props.timezone[key]['zona_horaria_id']}>{props.timezone[key]['nombre']}</option>
                                                            })}
                                                        </NativeSelect>}
                                                </FormControl>
                                                <form className={props.classes.form}>
                                                    <Divider></Divider>
                                                    
                                                    <TextField
                                                        required
                                                        className={props.classes.textField}
                                                        label={props.t ? props.t('users.form.newPassword') : 'Nueva contraseña'}
                                                        name="newPass"
                                                        onChange={event =>
                                                            props.handleFieldChange('newPass', event.target.value)
                                                        }
                                                        type="password"
                                                        value={props.newPass}
                                                        variant="outlined"
                                                        inputProps={{minLength :4}}
                                                    />
                                                    <TextField
                                                        required
                                                        className={props.classes.textField}
                                                        label={props.t ? props.t('users.form.confirmPassword') : 'Confirme Contraseña'}
                                                        name="confirmPass"
                                                        onChange={event =>
                                                            props.handleFieldChange('confirmPass', event.target.value)
                                                        }
                                                        type="password"
                                                        value={props.confirmPass}
                                                        variant="outlined"
                                                        inputProps={{minLength :4}}
                                                    />
                                                </form>
                                            </form>
                                            : props.valueCreate == 1 ?
                                            <PerfectScrollbar>
                                                <Paper style={{ minHeight: 50, 
                                                                    maxHeight: 400, 
                                                                    maxWidth: '100%',
                                                                    overflow: 'auto', 
                                                                    }}
                                                                    className={props.classes.customScrollBar}>
                                                    <List disablePadding>
                                                        {Object.keys(props.subclient).map(key => ( 
                                                            <ListItem
                                                                className={props.classes.listItem}
                                                                component="div"
                                                                key={props.subclient[key].cliente_subcliente_id} 
                                                                role={undefined} 
                                                                dense button
                                                                onClick={props.handleToggleCreate(props.subclient[key].cliente_subcliente_id)}
                                                            >
                                                                <ListItemText classes={{ primary: props.classes.listItemText }} id={props.subclient[key].cliente_subcliente_id} primary={props.subclient[key].nombre} /> 
                                                                <ListItemIcon className={props.classes.listItemIcon} >
                                                                    <Checkbox
                                                                        style ={{
                                                                            color: "#f57000",
                                                                        }}
                                                                        edge="start"
                                                                        checked={props.subclientCreate.includes(props.subclient[key].cliente_subcliente_id)}
                                                                        tabIndex={-1}
                                                                        disableRipple
                                                                        inputProps={{ 'aria-labelledby': key }}
                                                                    />
                                                                </ListItemIcon>                                             
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                </Paper> 
                                            </PerfectScrollbar>
                                            : null}
                                            
                                        </PortletContent>
                                        <PortletFooter className={props.classes.portletFooter} align="right">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {props.t ? props.t('users.button.save') : 'Guardar'}
                                            </Button>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseAdd}
                                            >
                                                {props.t ? props.t('users.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>   
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showEditEl}
                        onClose={props.handleCloseEdit}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showEditEl}>
                            <PerfectScrollbar>                            
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        <PortletHeader>
                                            <PortletLabel
                                                    //subtitle="Actualizar Contraseña"
                                                    title={props.t ? props.t('users.modal.editTitle') : 'Configurar usuario'}
                                                />
                                            <IconButton  onClick={props.handleCloseEdit}><CloseIcon/></IconButton>
                                        </PortletHeader>
                                        <AppBar position="static" style={{ backgroundColor: '#525252'}}>
                                            <Tabs value={props.value} onChange={props.handleChange} aria-label="simple tabs example">
                                                <Tab label={props.t ? props.t('users.tabs.user') : 'Usuario'}  />
                                                <Tab label={props.t ? props.t('users.tabs.groups') : 'Grupos'} /*disabled={!updateDisabled}*//>
                                            </Tabs>
                                        </AppBar>
                                        <PortletContent className={props.classes.porletContent}>
                                        
                                        { props.value == 0 ? 
                                            <form className={props.classes.form}>
                                                <TextField
                                                    required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validName}
                                                    helperText={props.validName ? (props.t ? props.t('users.form.helper.invalidName') : 'Por favor ingrese un nombre válido') : ' '}
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.name') : 'Nombre'}
                                                    name="nameEdit"
                                                    onChange={event =>
                                                        props.handleFieldChange('nameEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.nameEdit}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    onBlur={event =>
                                                        props.validateEmail(event.target.value)
                                                    }
                                                    error={props.validEmail}
                                                    helperText={props.validEmail ? (props.t ? props.t('users.form.helper.invalidEmail') : 'Por favor ingrese un email válido') : ' '}
                                                    required
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.email') : 'E-mail'}
                                                    name="emailEdit"
                                                    onChange={event =>
                                                        props.handleFieldChange('emailEdit', event.target.value)
                                                    }
                                                    type="email"
                                                    value={props.emailEdit}
                                                    variant="outlined"
                                                />
                                                <TextField
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.phone') : 'Teléfono'}
                                                    name="phoneEdit"
                                                    inputProps={{ pattern:'\x2b[0-9]+' }}
                                                    onChange={event =>
                                                        props.handleFieldChange('phoneEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.phoneEdit}
                                                    variant="outlined"
                                                />
                                                 <TextField
                                                    /*required
                                                    onBlur={event =>
                                                        props.validateName(event.target.value)
                                                    }
                                                    error={props.validCargo}
                                                    helperText={props.validCargo ? 'Por favor ingrese un cargo válido' : ' '}*/
                                                    className={props.classes.textField}
                                                    label={props.t ? props.t('users.form.position') : 'Cargo'}
                                                    name="cargoEdit"
                                                    onChange={event =>
                                                        props.handleFieldChange('cargoEdit', event.target.value)
                                                    }
                                                    type="text"
                                                    value={props.cargoEdit}
                                                    variant="outlined"
                                                />
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                    {props.t ? props.t('users.form.profile') : 'Perfil'}
                                                    </InputLabel>
                                                    { props.isLoading ? <div></div> : 
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            onChange={event =>
                                                                props.handleFieldChange('profileIdEdit', event.target.value)
                                                            }
                                                            defaultValue={props.profileIdEdit}
                                                            inputProps={{
                                                                name: 'name',
                                                                id: 'uncontrolled-native',
                                                            }}
                                                        >
                                                            {Object.keys(props.profile).map((key) => {                                                        
                                                                return <option value={props.profile[key]['reporte_perfil_id']}>{
                                                                    props.t(`user-management.role.${props.profile[key]['reporte_perfil_id']}.nombre`) ?? props.profile[key]['nombre']
                                                                }</option>
                                                            })}
                                                        </NativeSelect>}
                                                </FormControl>
                                                <FormControl className={props.classes.formControl}>   
                                                    <InputLabel shrink htmlFor="age-native-label-placeholder">
                                                    {props.t ? props.t('users.form.timezone') : 'ZonaHoraria'}
                                                    </InputLabel>
                                                    { props.isLoading ? <div></div> : 
                                                        <NativeSelect
                                                            className={props.classes.textField}
                                                            onChange={event =>
                                                                props.handleFieldChange('timezoneIdEdit', event.target.value)
                                                            }
                                                            defaultValue={props.timezoneIdEdit}
                                                            inputProps={{
                                                                name: 'name',
                                                                id: 'uncontrolled-native',
                                                            }}
                                                        >
                                                            {Object.keys(props.timezone).map((key) => {                                                        
                                                                return <option value={props.timezone[key]['zona_horaria_id']}>{props.timezone[key]['nombre']}</option>
                                                            })}
                                                        </NativeSelect>}
                                                </FormControl>
                                                <form className={props.classes.form}>
                                                    <Divider></Divider>
                                                    <FormHelperText style={{paddingBottom:'10px'}}>{props.t ? props.t('users.form.passwordHelper') : '• Ingrese los siguientes campos solo si quiere cambiar la clave actual.'} </FormHelperText>
                                                    <TextField
                                                        className={props.classes.textField}
                                                        label={props.t ? props.t('users.form.newPassword') : 'Nueva contraseña'}
                                                        name="newPassEdit"
                                                        onChange={event =>
                                                            props.handleFieldChange('newPassEdit', event.target.value)
                                                        }
                                                        type="password"
                                                        value={props.newPassEdit}
                                                        variant="outlined"
                                                        inputProps={{minLength :4}}
                                                    />
                                                    <TextField
                                                        className={props.classes.textField}
                                                        label={props.t ? props.t('users.form.confirmPassword') : 'Confirme Contraseña'}
                                                        name="confirmPassEdit"
                                                        onChange={event =>
                                                            props.handleFieldChange('confirmPassEdit', event.target.value)
                                                        }
                                                        type="password"
                                                        value={props.confirmPassEdit}
                                                        variant="outlined"
                                                        inputProps={{minLength :4}}
                                                    />
                                                </form>
                                            </form>
                                            : props.value == 1 ?
                                            <PerfectScrollbar>
                                                <Paper style={{ minHeight: 50, 
                                                                    maxHeight: 400, 
                                                                    maxWidth: '100%',
                                                                    overflow: 'auto', 
                                                                    //backgroundColor: '#333333',
                                                            
                                                                    }}
                                                                    className={props.classes.customScrollBar}>
                                                    <List disablePadding>
                                                        {Object.keys(props.subclient).map(key => ( 
                                                        
                                                            <ListItem
                                                                className={props.classes.listItem}
                                                                component="div"
                                                                key={props.subclient[key].cliente_subcliente_id} 
                                                                role={undefined} 
                                                                dense button
                                                                onClick={props.handleToggle(props.subclient[key].cliente_subcliente_id)}
                                                                //onClick={props.handleToggle(key)}
                                                            >
                                                                <ListItemText classes={{ primary: props.classes.listItemText }} id={props.subclient[key].cliente_subcliente_id} primary={props.subclient[key].nombre} /> 
                                                                <ListItemIcon className={props.classes.listItemIcon} >
                                                                    <Checkbox
                                                                        style ={{
                                                                            color: "#f57000",

                                                                        }}
                                                                        edge="start"
                                                                        checked={props.subclientEdit.includes(props.subclient[key].cliente_subcliente_id)}
                                                                        tabIndex={-1}
                                                                        disableRipple
                                                                        inputProps={{ 'aria-labelledby': key }}
                                                                    />
                                                                </ListItemIcon>                                              
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                </Paper> 
                                            </PerfectScrollbar>
                                            : null}
                                        </PortletContent>
                                        <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleSaved}
                                            >
                                                {props.t ? props.t('users.button.save') : 'Guardar'}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseEdit}
                                            >
                                                {props.t ? props.t('users.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>     
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={props.showDeleteEl}
                        onClose={props.handleCloseDelete}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={props.showDeleteEl}>
                            <PerfectScrollbar>
                                <div className={props.classes.modalDeleted}>                             
                                    <Portlet
                                        className={props.rootClassName}
                                    >
                                        
                                        <PortletLabel
                                            className={props.classes.portletFooter}
                                            //subtitle="Actualizar Contraseña"
                                            title={props.t ? props.t('users.deleteConfirm', { name: props.name }) : ("¿Esta seguro que desea eliminar el usuario "+props.name+"? ")}
                                        />
                                        
                                        
                                        <PortletFooter className={props.classes.portletFooter} align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={props.handleDeleted}
                                            >
                                                {props.t ? props.t('users.button.accept') : 'Aceptar'}
                                            </Button><>&nbsp;</> <>&nbsp;</> <>&nbsp;</>
                                            <Button
                                                color="primary"
                                                variant="outlined"
                                                onClick={props.handleCloseDelete}
                                            >
                                                {props.t ? props.t('users.button.cancel') : 'Cancelar'}
                                            </Button>
                                        </PortletFooter>
                                    </Portlet>                          
                                </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={props.open}
                        autoHideDuration={6000}
                        onClose={props.handleClose}
                        >
                            <SnackbarContent
                                className={props.isValid ? props.classes.snackContentOk
                                            : props.classes.snackContent}
                                aria-describedby="client-snackbar"
                                message={
                                    
                                            props.isValid ?
                                            <span id="client-snackbar" className={props.classes.message}>
                                                <CheckCircleIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {props.t ? props.t('users.snackbar.success') : 'Proceso Exitoso'}
                                            </span>
                                        :	<span id="client-snackbar" className={props.classes.message}>
                                                <ErrorIcon className={(props.classes.icon, props.classes.iconVariant)}/>
                                                {props.t ? props.t('users.snackbar.error') : 'Ha ocurrido un error, intente nuevamente.'}
                                                {" "}
                                                {props.t ? props.t('users.snackbar.errorHelp') : "(Asegurece que los campos 'nombre' y 'email', no esten vacios)"}
                                            </span>
                                    
                                }
                                action={[
                                    <IconButton key="close" aria-label="close" color="inherit" onClick={props.handleClose}>
                                        <CloseIcon className={props.classes.icon}/>
                                    </IconButton>
                                ]}
                            />
                    </Snackbar>
                </div>
                
            }
            </div>
        )

}

export default compose(withRouter, withStyles(styles), withTranslation())(UserList);